import { Box, FormGroup, FormControlLabel, Typography } from "@mui/material";
import MUISwitch from "@mui/material/Switch";

const Switch = ({
  value,
  onChange,
  label,
  disabled,
  labelPosition = "horizontal",
}) => {
  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  return (
    <FormGroup sx={{ marginLeft: "4px" }}>
      {labelPosition === "horizontal" ? (
        <FormControlLabel
          slotProps={{ typography: { fontSize: "10px", fontWeight: "bold" } }}
          control={
            <MUISwitch
              checked={Boolean(value)}
              onChange={handleChange}
              disabled={disabled}
              size="small"
            />
          }
          label={label}
        />
      ) : (
        <Box>
          <Typography
            sx={{ fontSize: "10px", fontWeight: "bold" }}
            textAlign="center"
          >
            {label}
          </Typography>
          <Box
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              height: "26px",
              display: "flex",
              alignItems: "center",
              padding: "4px",
            }}
          >
            <MUISwitch
              checked={Boolean(value)}
              onChange={handleChange}
              disabled={disabled}
              size="small"
            />
          </Box>
        </Box>
      )}
    </FormGroup>
  );
};

export default Switch;
